module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"contactSupport":"サポート問い合わせ","FlowSolutions":"運営会社情報","FAQ":"よくある質問","SupportPage":"サポートページ"}}')
  delete Component.options._Ctor
}
